import {
    MoonOutlined, SunOutlined,
} from '@ant-design/icons';
import {
    Switch, Tooltip,
} from 'antd';
import { useMemo } from 'react';

import { useUIStore } from '@/stores';

export const ThemeSwitcher = () => {
    const { theme, setTheme } = useUIStore();

    const toggleTheme = (checked: boolean) => {
        setTheme(checked ? 'dark' : 'light');
    };

    const tooltipTitle = useMemo(() => {
        return theme === 'dark' ? 'Змінити на світлу тему' : 'Змінити на темну тему';
    }, [theme]);

    return (
        <Tooltip title={tooltipTitle}>
            <Switch
                checked={theme === 'dark'}
                onChange={toggleTheme}
                checkedChildren={<MoonOutlined />}
                unCheckedChildren={<SunOutlined />}
            />
        </Tooltip>
    );
};
